import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum UserActivityProjectId {
  ADMIN = 'admin',
  AGENCY = 'agency',
  AI = 'ai',
  ALFRED = 'alfred',
  API = 'api',
  BOOKING = 'booking',
  CRM = 'crm',
  FILES = 'files',
  ID = 'id',
  PARTNER = 'partner',
  PMS = 'pms',
  POS = 'pos',
  PREVIO2 = 'previo2',
  SCAN_ID = 'scan-id',
  SELF_SERVICE_BAR = 'self-service-bar',
}

export type UserActivityProjectColor =
  | Color.POSITIVE
  | Color.WARNING
  | Color.INFO
  | Color.PRIMARY
  | Color.GREY_600

export class UserActivityProject extends Codebook<UserActivityProjectId> {
  static readonly ADMIN = new UserActivityProject(
    UserActivityProjectId.ADMIN,
    () => $t('Admin'),
    Color.PRIMARY,
  )
  static readonly AGENCY = new UserActivityProject(
    UserActivityProjectId.AGENCY,
    () => $t('Agency'),
    Color.GREY_600,
  )
  static readonly AI = new UserActivityProject(
    UserActivityProjectId.AI,
    () => $t('AI'),
    Color.GREY_600,
  )
  static readonly ALFRED = new UserActivityProject(
    UserActivityProjectId.ALFRED,
    () => $t('Alfred'),
    Color.GREY_600,
  )
  static readonly API = new UserActivityProject(
    UserActivityProjectId.API,
    () => $t('API'),
    Color.GREY_600,
  )
  static readonly BOOKING = new UserActivityProject(
    UserActivityProjectId.BOOKING,
    () => $t('Booking'),
    Color.GREY_600,
  )
  static readonly CRM = new UserActivityProject(
    UserActivityProjectId.CRM,
    () => $t('CRM'),
    Color.POSITIVE,
  )
  static readonly FILES = new UserActivityProject(
    UserActivityProjectId.FILES,
    () => $t('Files'),
    Color.GREY_600,
  )
  static readonly ID = new UserActivityProject(
    UserActivityProjectId.ID,
    () => $t('ID'),
    Color.WARNING,
  )
  static readonly PARTNER = new UserActivityProject(
    UserActivityProjectId.PARTNER,
    () => $t('Partner'),
    Color.GREY_600,
  )
  static readonly PMS = new UserActivityProject(
    UserActivityProjectId.PMS,
    () => $t('PMS'),
    Color.INFO,
  )
  static readonly POS = new UserActivityProject(
    UserActivityProjectId.POS,
    () => $t('POS'),
    Color.GREY_600,
  )
  static readonly PREVIO2 = new UserActivityProject(
    UserActivityProjectId.PREVIO2,
    () => $t('Previo 2'),
    Color.GREY_600,
  )
  static readonly SCAN_ID = new UserActivityProject(
    UserActivityProjectId.SCAN_ID,
    () => $t('Scan ID'),
    Color.GREY_600,
  )
  static readonly SELF_SERVICE_BAR = new UserActivityProject(
    UserActivityProjectId.SELF_SERVICE_BAR,
    () => $t('Self service bar'),
    Color.GREY_600,
  )

  private constructor(
    public readonly id: UserActivityProjectId,
    public readonly name: () => string,
    public readonly color: UserActivityProjectColor,
  ) {
    super(id)
  }
}
